import * as z from "zod";

export const lunchMenuitemSchema = z.object({
  date: z.coerce.date(),
  labels: z.array(z.string()),
});
export const lunchMenuitemsSchema = z.array(lunchMenuitemSchema);

export type LunchMenuitem = z.infer<typeof lunchMenuitemSchema>;
export type LunchMenuitems = z.infer<typeof lunchMenuitemsSchema>;
